<template>
  <no-ssr>
    <div>
      <SolutionsVideo @cannotplay="onSolutionCmpError" v-if="canPlayVideo" />
      <Solutions v-show="!canPlayVideo" />
    </div>
  </no-ssr>
</template>

<script>
import SolutionsVideo from "../home-solutions-video";
import Solutions from "./";
export default {
  components: { SolutionsVideo, Solutions },
  data() {
    return {
      canPlayVideo: true,
    };
  },
  methods: {
    onSolutionCmpError() {
      console.log("---errror");
      this.canPlayVideo = false;
    },
    checkCanPlayVideo() {
      try {
        return !/MicroMessenger/.test(window.navigator.userAgent);
      } catch (e) {
        return false;
      }
    },
  },
  beforeMount() {
    this.canPlayVideo = this.checkCanPlayVideo();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home-solutions/switch.vue